// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-f867f54c]{background-color:#edeef0;height:40px}", ""]);
// Exports
module.exports = exports;
